import React from 'react';
import { MainMenu } from './screens/mainmenu.js';
import { Verification } from './screens/verification.js';
import {OTPVerification } from './screens/otpverification.js';

export const Screens = {
    MAIN_MENU: 'Main Menu',
    VERIFICATION: 'Verification',
    OTP_VERIFICATION: 'OTP Verification'
}

export class ScreenContainer extends React.Component {
    constructor( props ) {
        super( props );
        this.state = {
            currentScreen: Screens.MAIN_MENU,
            userAction: null,
            addtlParams: null,
        };
    }

    setScreenState = ( screen, userAction, addtlParams ) => {
        this.setState({
            currentScreen: screen,
            userAction: userAction,
            addtlParams: addtlParams,
        });
    }

    getMenuSelection = ( selection ) => {
        var userAction;
        switch ( selection )
        {
            case 'NEW':
            {
                userAction = 'New Site Access';
            }
            break;

            case 'UPDATE':
            {
                userAction = 'Update Site Access';
            }
            break;

            case 'CHECK':
            {
                userAction = 'Check Site Access'
            }
            break;

            case 'CREATE': 
            {
                userAction = 'Research Access'
            }
            break;
        }

        this.setState({
            userAction: userAction,
            currentScreen: Screens.VERIFICATION,
        });
    }

    render() {
        
        var screen;

        switch( this.state.currentScreen )
        {
            case Screens.MAIN_MENU: 
            {
                screen = <MainMenu menuSelection={this.getMenuSelection} apiURLs={this.props.apiURLs}/>
            }
            break;

            case Screens.VERIFICATION:
            {
                screen = <Verification sessionID={this.props.sessionID} userAction={this.state.userAction} setScreenState={this.setScreenState}  apiURLs={this.props.apiURLs} />
            }
            break;

            case Screens.OTP_VERIFICATION:
            {
                screen = <OTPVerification 
                    userAction={this.state.userAction}
                    email={this.state.addtlParams[ 'email' ]} 
                    guid={this.state.addtlParams[ 'guid' ]}
                    sessionID = {this.state.addtlParams[ 'sessionID' ]}
                    setScreenState={this.setScreenState}
                    apiURLs={this.props.apiURLs} 
                />
            }
            break;
        }

        return(
            screen
        );
    }
}